import React from 'react';

import PropTypes, { any } from 'prop-types';
import OfficialSingle from './OfficialSingle';
import OfficialTwoThree from './OfficialTwoThree';
import SimpleTwoThree from './SimpleTwoThree';
import SimpleOne from './SimpleOne';

const printCardTypes = {
    OfficialSingle: 'official-single',
    OfficialTwoThree: 'official-two-three',
    Simple: 'simple',
    SimpleTwoThree: 'simple-two-three',
};

const PrintCard = ({ type, hasBreak, drawName, matchPosition, courtNumber, scoringFormat, scoringFormatDisplay, displayNameOne, displayNameTwo, displayNameThree, displayNameFour, match }) => {
    let Component;
    switch (type) {
        case printCardTypes.OfficialSingle:
            Component = (
                <OfficialSingle
                    hasBreak={hasBreak}
                    match={match}
                />
            );
            break;
        case printCardTypes.OfficialTwoThree:
            Component = (
                <OfficialTwoThree
                    hasBreak={hasBreak}
                    match={match}
                />
            );
            break;
        case printCardTypes.Simple:
            Component = (
                <SimpleOne
                    hasBreak={hasBreak}
                    drawName={drawName}
                    matchPosition={matchPosition}
                    courtNumber={courtNumber}
                    scoringFormat={scoringFormat}
                    scoringFormatDisplay={scoringFormatDisplay}
                    displayNameOne={displayNameOne}
                    displayNameTwo={displayNameTwo}
                    displayNameThree={displayNameThree}
                    displayNameFour={displayNameFour}
                />
            );
            break;
        case printCardTypes.SimpleTwoThree:
            Component = (
                <SimpleTwoThree
                    hasBreak={hasBreak}
                    drawName={drawName}
                    matchPosition={matchPosition}
                    courtNumber={courtNumber}
                    scoringFormat={scoringFormat}
                    scoringFormatDisplay={scoringFormatDisplay}
                    displayNameOne={displayNameOne}
                    displayNameTwo={displayNameTwo}
                    displayNameThree={displayNameThree}
                    displayNameFour={displayNameFour}
                />
            );
            break;
        default:
            Component = null;
            break;
    }

    return Component;
};

export default PrintCard;

PrintCard.propTypes = {
    type: PropTypes.string,
    is2Up: PropTypes.bool,
    drawName: PropTypes.string,
    matchPosition: PropTypes.string,
    refereeName: PropTypes.string,
    courtNumber: PropTypes.string,
    scoringFormat: PropTypes.number,
    scoringFormatDisplay: PropTypes.string,
    displayNameOne: PropTypes.string,
    displayNameTwo: PropTypes.string,
    match: PropTypes.objectOf(any).isRequired,
};

PrintCard.defaultProps = {
    type: '',
    is2Up: false,
    drawName: '',
    matchPosition: '',
    refereeName: '',
    courtNumber: '',
    scoringFormat: '',
    scoringFormatDisplay: '',
    displayNameOne: '',
    displayNameTwo: '',
};
